import type {
  UpdateEntityFileSelectFunc,
  UpdateEntityFileUploadFunc,
  VideoComponentData,
} from './../ricos-content';
import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

export const VIDEO_TYPE = 'wix-draft-plugin-video';

export const videoButtonsTypes = { video: 'video', youTube: 'youTube' };

export interface VideoPluginEditorConfig extends EditorPluginConfig {
  [key: string]: any;
  /**
   * @description Sets default `disableDownload` value for newly uploaded videos.
   */
  disableDownloadDefault?: boolean;
  handleFileSelection?: FileSelectionHandlerFn;
  handleFileUpload?: FileUploadHandlerFn;

  // @todo: next-major: remove deprecated Promise<string> return value
  /**
   * @description Promise<string> is deprecated, please use string as a return value.
   */
  getVideoUrl?: (src: { pathname: string }) => string | Promise<string>;
  getThumbnailUrl?: (src: { pathname: string }) => string | Promise<string>;
  /**
   * Callback containing the video progress.
   * `played` - played progress as a fraction (0 to 1).
   * `playedSeconds` - played progress in seconds.
   * `id` - id of the video.11
   */
  onProgress?: (args: { played: number; playedSeconds: number; id: string }) => void;
  progressInterval?: number;
}
export interface VideoPluginViewerConfig extends ViewerPluginConfig {
  getVideoUrl?: VideoPluginEditorConfig['getVideoUrl'];
  getThumbnailUrl?: VideoPluginEditorConfig['getThumbnailUrl'];
  [key: string]: any;
}

export type FileSelectionHandlerFn = (
  updateEntity: UpdateEntityFileSelectFunc<VideoComponentData>
) => void;

export type FileUploadHandlerFn = (
  file: File,
  updateEntity: UpdateEntityFileUploadFunc<VideoComponentData>
) => void;
